import { useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

export default function LaborWarningModal({
  path,
  setShowWarningComponent,
  mismatchDetails = [],
}) {
  const navigate = useNavigate();
  const hasDetails = Array.isArray(mismatchDetails) && mismatchDetails.length > 0;

  return (
    <Modal
      show={true}
      onHide={() => setShowWarningComponent(false)}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Warning: Labor Mismatch</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {hasDetails ? (
          <>
            <p>
              The following option{mismatchDetails.length === 1 ? " has" : "s have"} labor
              quantities that do not match the total number of drops:
            </p>
            <ul className="mb-0">
              {mismatchDetails.map((detail) => (
                <li key={detail.option}>
                  <strong>Option {detail.option}:</strong> Labor is{" "}
                  <strong>{detail.direction}</strong>. Labor quantity is{" "}
                  <strong>{detail.laborQuantity}</strong>, but drops are{" "}
                  <strong>{detail.expectedDrops}</strong>.
                </li>
              ))}
            </ul>
          </>
        ) : (
          "The Quantity of Labor does NOT match the Total Number of Drops."
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShowWarningComponent(false)}>
          Go Back
        </Button>
        <Button
          variant="dark"
          onClick={() => {
            setShowWarningComponent(false);
            navigate(path);
          }}
        >
          Continue Anyway
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
